import React from "react";
import { Maybe, SanityFormPermitRequester } from "@graphql-types";
import JotformEmbed from "react-jotform-embed";
import { Heading } from "@global";
import styled from "styled-components";
import { marginBottom } from "@util/constants";

interface Props {
  data: Maybe<SanityFormPermitRequester> | undefined;
}

const FormPermitWrapper = styled.div`
  width: 100%;
  .form-header {
    ${marginBottom.m}
  }
  iframe {
    width: 100%;
  }
`;

/** Permit requester form – title and optional Jotform embed only (no dynamic sections). */
function FormPermitRequester({ data }: Props) {
  if (data == null) return null;

  const formData = data as { title?: string; formID?: string };

  return (
    <FormPermitWrapper>
      <div className="form-header">
        <Heading data={{ design: "h2", tag: "h2" }}>{formData.title}</Heading>
      </div>
      {formData.formID && <JotformEmbed src={formData.formID} />}
    </FormPermitWrapper>
  );
}

export default FormPermitRequester;
